import { NavLink, Outlet } from 'react-router-dom';
import { RequireRole } from '@/features/auth/RequireRole';

const tabs = [
  { to: '/admin/shamans', label: '무당' },
  { to: '/admin/pricing', label: '구독 가격' },
  { to: '/admin/bookings', label: '예약' },
  { to: '/admin/subscriptions', label: '구독 결제' },
];

export function AdminLayout() {
  return (
    <RequireRole role="admin">
      <div className="space-y-4">
        <nav className="flex gap-2 overflow-x-auto pb-1">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg text-base whitespace-nowrap ${
                  isActive ? 'bg-brand text-white' : 'bg-white border border-ink-line text-ink'
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </RequireRole>
  );
}
